import {
  COMMUNICATION_ENABLE_COMMENTS,
  COMMUNICATION_ENABLE_DIRECT_MESSAGES,
  COMMUNICATION_ENABLE_REVIEWS
} from '../constants';

export const postTypePermissionMap = {
  direct_message: COMMUNICATION_ENABLE_DIRECT_MESSAGES,
  review: COMMUNICATION_ENABLE_REVIEWS,
  comment: COMMUNICATION_ENABLE_COMMENTS
};
